/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rekam_GInputs */

const en_tut_rekam_g = /** @type {(inputs: Tut_Rekam_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordings help whoever could not attend, but they must never be quiet. Here a recording only runs once everyone connected has consented.`)
};

const id_tut_rekam_g = /** @type {(inputs: Tut_Rekam_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekaman berguna untuk yang tidak bisa hadir, tapi tidak boleh diam-diam. Di sini rekaman hanya berjalan kalau semua yang terhubung sudah menyetujuinya.`)
};

/**
* | output |
* | --- |
* | "Recordings help whoever could not attend, but they must never be quiet. Here a recording only runs once everyone connected has consented." |
*
* @param {Tut_Rekam_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rekam_g = /** @type {((inputs?: Tut_Rekam_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rekam_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rekam_g(inputs)
	return en_tut_rekam_g(inputs)
});